export default __webpack_public_path__ + "img/d46182a113627ce444d33e00f6cec38e.svg";